import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";

const SocialEdit = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const id = useParams();
  const navigate = useNavigate();

  let token = localStorage.getItem("accessToken");

  const fetchlinksdata = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-social-media-links",
    };

    axios(config)
      .then(function (response) {
        setData(response?.data?.data[0]);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchlinksdata();
  }, []);

  useEffect(() => {
    if (data) {
      setValue("facebook", data?.facebook_link);
      setValue("instagram", data?.instagram_link);
      setValue("gmail", data?.gmail_link);
      setValue("linkedin", data?.linkedin_link);
      setValue("twitter", data?.twitter_link);
    }
  }, [data]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_API + "save-social-media-links",
        data: {
          id: id.socialId,
          facebook_link: data.facebook,
          gmail_link: data.gmail,
          instagram_link: data.instagram,
          linkedin_link: data.linkedin,
          twitter_link: data.twitter,
        },
        headers: {
          "x-access-token": token,
        },
      });
      if (res.status == 200) {
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        setLoading(false);
        navigate("/social-media-links");
      }
    } catch (error) {
      if (error?.response !== "" && error?.response?.data?.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
      setLoading(false);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        {data && (
          <div className="bottom">
            <div className="modal-content">
              <div className="modal-content-title">View Social Links</div>
              <p>&nbsp;</p>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="custome-form-group">
                  <label>Facebook</label>
                  <input
                    type="text"
                    name="facebook"
                    {...register("facebook", {
                      required: "This field is required",
                    })}
                    placeholder="Enter Facebook Link"
                    className="custome-input"
                  />
                  {errors.facebook && (
                    <div className="invalid-feedback">
                      {errors.facebook.message}
                    </div>
                  )}
                </div>

                <div className="custome-form-group">
                  <label>Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    {...register("instagram", {
                      required: "This field is required",
                    })}
                    placeholder="Enter Instagram Link"
                    className="custome-input"
                  />
                  {errors.instagram && (
                    <div className="invalid-feedback">
                      {errors.instagram.message}
                    </div>
                  )}
                </div>
                <div className="custome-form-group">
                  <label>Linkedin</label>
                  <input
                    type="text"
                    name="linkedin"
                    {...register("linkedin", {
                      required: "This field is required",
                    })}
                    placeholder="Enter Linkedin Link"
                    className="custome-input"
                  />
                  {errors.linkedin && (
                    <div className="invalid-feedback">
                      {errors.linkedin.message}
                    </div>
                  )}
                </div>
                <div className="custome-form-group">
                  <label>Gmail</label>
                  <input
                    type="text"
                    name="gmail"
                    {...register("gmail", {
                      required: "This field is required",
                    })}
                    placeholder="Enter Gmail Link"
                    className="custome-input"
                  />
                  {errors.gmail && (
                    <div className="invalid-feedback">
                      {errors.gmail.message}
                    </div>
                  )}
                </div>
                <div className="custome-form-group">
                  <label>Twitter</label>
                  <input
                    type="text"
                    name="twitter"
                    {...register("twitter", {
                      required: "This field is required",
                    })}
                    placeholder="Enter Twitter Link"
                    className="custome-input"
                  />
                  {errors.twitter && (
                    <div className="invalid-feedback">
                      {errors.twitter.message}
                    </div>
                  )}
                </div>
                <button type="submit" className="approveButton">
                  Save
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SocialEdit;
